export function getAppVersion() {
  const fromWindow =
    typeof window !== "undefined" ? window.APP_VERSION : undefined;
  const raw = fromWindow || process.env.REACT_APP_VERSION || "dev";
  return String(raw).trim() || "dev";
}

export function formatAppVersionLabel(version = getAppVersion()) {
  const value = String(version || "dev").trim() || "dev";
  if (value.toLowerCase() === "dev") {
    return "dev";
  }
  return /^v/i.test(value) ? value : `v${value}`;
}
